module.exports = __webpack_public_path__ + "img/background026.18bb6eac.jpg";